import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CORE_FEATURE, CoreState, StateWithCore } from '../core-state';

export const getCustomCoreState: MemoizedSelector<StateWithCore, CoreState> =
  createFeatureSelector<CoreState>(CORE_FEATURE);
